import type { OpenDepositPopupOptions } from "./DepositPopup.types";

export const DEPOSIT_POPUP_EVENT = "show-deposit-popup";
export const CLOSE_DEPOSIT_POPUP_EVENT = "close-deposit-popup";

type PendingOpen = {
  options: OpenDepositPopupOptions;
  at: number;
};

// DepositPopup 是 lazy 的：App 挂载后才开始下载它的 chunk，而监听器要等 chunk 落地、
// 组件 mount 才注册。用户在这段窗口里点充值入口，事件派发出去没人接就永久丢失 ——
// 表现为点了没反应。所以派发的同时留一份，组件挂载后自己来认领。
let pendingOpen: PendingOpen | null = null;
// 超过这个时间不再补：用户早已离开当时的操作意图，突然弹充值反而莫名其妙。
const PENDING_OPEN_TTL_MS = 15000;

export const openDepositPopup = (options?: OpenDepositPopupOptions) => {
  const detail = options || {};
  pendingOpen = { options: detail, at: Date.now() };
  window.dispatchEvent(
    new CustomEvent(DEPOSIT_POPUP_EVENT, {
      detail,
    })
  );
};

export const closeDepositPopup = () => {
  // 关闭意图优先于任何还没被认领的打开意图，否则组件挂载后会又弹回来
  pendingOpen = null;
  window.dispatchEvent(new CustomEvent(CLOSE_DEPOSIT_POPUP_EVENT));
};

/** 监听器接住事件时调用，标记这次打开已被消费，避免组件挂载时重复弹。 */
export const consumeDepositOpen = () => {
  pendingOpen = null;
};

// ── 充值弹窗「是否正开着」的模块级镜像 ──────────────────────────────
// DepositPopup 的 visible 是组件内部 useState，外部读不到；而它是**浮层不改路由**，
// 所以排队弹窗（useQueuedPopup）的 blockedPaths: ['/recharge'] 挡不到它。
// 由 DepositPopup 在 visible 变化时把状态同步到这里，供其它弹窗在 shouldShow 里判断
// 「充值弹窗开着就别插队」。消费方见 useNotLoginNotRechargePopup。
let popupOpen = false;

/** 由 DepositPopup 调用，同步自身开合状态（含卸载时置 false）。 */
export const setDepositPopupOpen = (open: boolean) => {
  popupOpen = open;
};

/** 充值弹窗当前是否正开着。 */
export const isDepositPopupOpen = (): boolean => popupOpen;

/** 组件挂载后调用：取回派发时还没人监听的那次打开（取一次即清空）。 */
export const claimPendingDepositOpen = (): PendingOpen | null => {
  const p = pendingOpen;
  pendingOpen = null;
  if (!p || Date.now() - p.at > PENDING_OPEN_TTL_MS) return null;
  return p;
};
